export const PROJECT_TYPE_LABEL: Record<string, string> = {
  web_dev: 'Web development',
  custom_software: 'Custom software',
  it_services: 'IT services',
  other: 'Other',
};

export const DEFAULT_PROJECT_TYPE = 'web_dev';

export type ProjectStatus = 'active' | 'on_hold' | 'completed' | 'archived';

/** Ordered for the status dropdown. `active` is surfaced as "In progress". */
export const PROJECT_STATUSES: ProjectStatus[] = ['active', 'on_hold', 'completed', 'archived'];

export const PROJECT_STATUS_LABEL: Record<ProjectStatus, string> = {
  active: 'In progress',
  on_hold: 'On hold',
  completed: 'Completed',
  archived: 'Archived',
};

export const PROJECT_STATUS_TONE: Record<ProjectStatus, 'neutral' | 'success' | 'warning' | 'info'> = {
  active: 'success',
  on_hold: 'warning',
  completed: 'info',
  archived: 'neutral',
};
